import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出清单")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "总计：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_export_btn = _resolveComponent("export-btn")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_table_wrapper, {
        "row-key": "uuid",
        size: "small",
        border: true,
        "data-source": _ctx.value||[],
        columns: _ctx.detailColumns,
        showCheckbox: false,
        maxHeight: _ctx.DEFAULTTABLEMAXHEIGHT
      }, {
        buttons: _withCtx(() => [
          _createVNode(_component_export_btn, {
            api: 'ticket/exportMaterial/' + _ctx.id,
            selectedIds: _ctx.selectedIds,
            tableColumn: _ctx.detailColumns,
            method: "get"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["api", "selectedIds", "tableColumn"])
        ]),
        count: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(_ctx.$filters.formatMoneyZero(record.count)), 1)
        ]),
        price: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(_ctx.$filters.formatMoneyZero(record.price)), 1)
        ]),
        totalPrice: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(_ctx.$filters.formatMoneyZero(record.totalPrice)), 1)
        ]),
        isInnerContract: _withCtx(({ record, index }) => [
          (record.isInnerContract === true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "是"))
            : _createCommentVNode("", true),
          (record.isInnerContract === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "否"))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatMoney(_ctx.totalPrice)) + "元", 1),
              _createElementVNode("span", null, "（" + _toDisplayString(_ctx.$filters.moneyToChinese(_ctx.totalPrice)) + "）", 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["data-source", "columns", "maxHeight"])
    ]),
    _: 1
  }))
}